<div class="cf-dlg">
<div class="cf-dlg-header">
  <div class="cf-dlg-icon cf-dlg-icon--red">
    <mat-icon>history</mat-icon>
  </div>
  <div class="rf-header-text">
    <h2 class="cf-dlg-title">Rectificar factura</h2>
    <p class="cf-dlg-subtitle" *ngIf="invoice?.invoiceNumber">{{ invoice.invoiceNumber }}</p>
  </div>
  <button mat-icon-button class="cf-dlg-close" (click)="closeDialog()" [disabled]="doing" aria-label="Cerrar">
    <mat-icon>close</mat-icon>
  </button>
</div>

<ng-container *ngIf="!doing; else processing">
  <div class="cf-dlg-body">
    <div class="rf-summary" *ngIf="invoice">
      <div class="rf-summary__row" *ngIf="invoice.receiverName">
        <span class="rf-summary__label">Cliente</span>
        <span class="rf-summary__value">{{ invoice.receiverName }}</span>
      </div>
      <div class="rf-summary__row" *ngIf="invoice.invoiceRelease">
        <span class="rf-summary__label">Fecha</span>
        <span class="rf-summary__value">{{ invoice.invoiceRelease | date:'dd/MM/yyyy' }}</span>
      </div>
      <div class="rf-summary__row" *ngIf="invoice.total != null">
        <span class="rf-summary__label">Total</span>
        <span class="rf-summary__value rf-summary__value--amount">{{ invoice.total | number:'1.2-2' }} €</span>
      </div>
    </div>

    <div class="rf-warning">
      <mat-icon>warning</mat-icon>
      <div>
        <strong>Esta acción no se puede deshacer.</strong>
        <span>¿Seguro que quieres rectificar esta factura?</span>
      </div>
    </div>
  </div>

  <div class="cf-dlg-footer">
    <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="closeDialog()">Cancelar</button>
    <button mat-flat-button class="cf-dlg-btn-danger" (click)="rectification()">
      <mat-icon>history</mat-icon> Rectificar
    </button>
  </div>
</ng-container>

<ng-template #processing>
  <app-loading-state message="Rectificando factura…"></app-loading-state>
</ng-template>
</div>
